import {AppConfig} from './app-config';
import {LogLevel} from '../logger/log-level';
import {ConsoleAppenderConfig} from '../logger/appenders/console/console-appender-config';
import {XhrAppenderConfig} from '../logger/appenders/xhr/xhr-appender-config';
import {LocalStorageAppenderConfig} from '../logger/appenders/local-storage/local-storage-appender-config';
import {SentryBreadcrumbsAppenderConfig} from '../logger/appenders/sentry-breadcrumbs/sentry-breadcrumbs-appender-config';
import {LoggerConfig} from '../logger/logger-config';
import {PageType} from '../../types/page-type';
import {PageListType} from '../../types/page-list-type';
import {TvModuleName} from '../modules/tv-module-name';

export const DEFAULT_APP_CONFIG: AppConfig = {
  hotelId: window.HOTEL_ID?.toLowerCase()?.trim(),
  hotelUid: window.HOTEL_UID?.toLowerCase()?.trim(),
  region: window.HOTEL_REGION?.toLowerCase()?.trim() as AppConfig['region'],

  production: !IS_DEVELOPMENT,

  logger: {
    ...new LoggerConfig(),
    triggerLevel: LogLevel.Debug,
    contextSize: IS_DEVELOPMENT ? 0 : 20,
    console: {
      ...new ConsoleAppenderConfig(),
      enabled: true,
      triggerLevel: LogLevel.Debug,
      objectSerialization: 'native',
      nativeLevels: false,
      colors: false,
      contextSize: 0,
      timestamp: false,
    },
    xhr: {
      ...new XhrAppenderConfig(),
      enabled: false,
    },
    localStorage: {
      ...new LocalStorageAppenderConfig(),
      triggerLevel: LogLevel.Error,
      contextSize: 20,
      size: 20,
      enabled: false,
    },
    sentryBreadcrumbs: {
      ...new SentryBreadcrumbsAppenderConfig(),
      enabled: !IS_DEVELOPMENT,
      triggerLevel: LogLevel.Debug,
    },
  },
  storage: {
    localStoragePrefix: '',
  },
  bootstrap: {
    timeout: 2 * 60 * 1000, // 2 mins timeout
    doNotReboot: false,
    rebootTimeout: 10_000,
  },

  // TODO разобраться с дефолтным конфигом.
  // TODO убрать комментарии касательно типов, перенести информацию в jsdoc AppConfig

  tv_daemon_url: 'http://10.12.0.200:8080/',
  tv_channellist_type: 'mosaic', // vertical, vertical_new, not_vertical(classic), mosaic
  tv_auth_function: undefined, // callback on auth
  tv_key_source: 'off', // [off|on] on - handled by Hoteza

  applyTizenTEPClone: [
    {
      serialNumbers: [],
      updateAllTVs: false,
      url: '',
    },
  ],

  use_ssl: true, //[true, false] потом 'auto'

  /**
   * Use 12h format for time display
   */
  hour12: false,

  remoteDebug: {
    debugSessionDuration: 6 * 60, // 6 hours
    engine: 'weinre',
    turningOnFor: {
      macAddresses: [],
      rooms: [],
      ips: [],
    },
  },

  timezone: 'Europe/Moscow',
  defaults: {language: 'en'},

  rcu_url: 'http://10.88.0.1:8112/',
  rcu_ac_temp_range: {
    min: 16,
    max: 32,
  },
  rcu: {
    periodical_check: true,
    batch_check: false,
    check_interval: 5000,
  },
  secret: 'hoteza',
  modules: [
    TvModuleName.Radio, // Радио станции
    TvModuleName.WakeUpCall, // установка будильника с красочными фонами и приятными мелодиями
    TvModuleName.ScandicWelcome, // Welcome экран в стиле Scandic
    TvModuleName.RemoteControl, // Управление ТВ из Hoteza App

    //		'VOD',				// Video on Demand (Native) рекомендовано
    //		'VODhtml5',			// VOD (HTML5)
    //		'AirStream',		// AirStream
    //		'Housekeeping',		// Housekeeping модуль, управление статусом комнат
    //		'MOD',				// Music on Demand
    //		'VerticalChannel',	// Новый вертикальный список каналов (simple) (при config.tv_channellist_type =
    // vertical_new)

    // кастомные модули
    //		'UpdateInfoGorki',	// состояние трасс Горки Город
    //		'Sanatorium',		// расписание процедур Sanatorium
    //		'DoorEye',			// Реализация китайского глазка с переключением на AV
    //		'Peninsula_rs232',	// Приём команд от пультов Peninsula
  ],
  weather: {
    enabled: true,
    icon: true,
    plus: true,
  },
  express_checkout: false,

  widgets: {
    weather: {
      // преднастройки
      // "С" - Celsius, or "F" - Fahrenheit
      valueTemperature: 'C',
      // "Kmph" - km per hour, or Miles
      valueWind: 'Kmph',
      // "mmHg" - millimeters of mercury, or "inHg" - inches of mercury
      valuePressure: 'mmHg',
      // "fade" - затухание и появление (использовать на старых телевизорах)
      // "rotate" - анимация поворота по горизонтали (работает на новых телевизорах)
      howInterfaceSwitches: 'fade',
      // Duration of weather changing in ms
      timeoutUpdate: 300000,
    },
    wakeup: {
      welcome_text: 'nice_day',
      tracks: [
        {
          title: 'Inspiration_Morning',
          audio: 'i/wakeup/audio/01.mp3',
          video: 'i/wakeup/video/01.mp4',
          image: 'i/wakeup/image/01.jpg',
        },
        {
          title: 'Birds_in_a_Forest',
          audio: 'i/wakeup/audio/02.mp3',
          video: 'i/wakeup/video/02.mp4',
          image: 'i/wakeup/image/02.jpg',
        },
        {
          title: 'Morning_Touch',
          audio: 'i/wakeup/audio/03.mp3',
          video: 'i/wakeup/video/03.mp4',
          image: 'i/wakeup/image/03.jpg',
        },
        {
          title: 'Brand_New_Day',
          audio: 'i/wakeup/audio/04.mp3',
          video: 'i/wakeup/video/04.mp4',
          image: 'i/wakeup/image/04.jpg',
        },
        {
          title: 'Summer_Jump',
          audio: 'i/wakeup/audio/05.mp3',
          video: 'i/wakeup/video/05.mp4',
          image: 'i/wakeup/image/05.jpg',
        },
      ],
    },
  },

  modules_settings: {
    CustomNotification: {
      newmessage: {
        text_length: {
          small: 83,
          big: 113,
        },
      },
      textMessage: {
        text_length: {
          small: 83,
          big: 113,
        },
      },
    },
    // 'ViewBill': {
    // 'customDateFormat': 'L'
    // }
  },

  animation: {
    spring: {
      used: true,
    },
  },

  menu: 'scandic',
  preload_images: 2, // false - без предзагрузки, 1 - параллельно, быстрее, но залипает, 2 - последовательно,
  // медленнее, но визуальнее, 3 - в процессе навигации, существенно ускоряет старт ТВ
  preload_threads: 3, // Количество потоков предзагрузки. Только для preload_images == 2,

  shop: {
    lock_ordering: false,
    use_confirm_for_order: true,
  },
  time_picker: {
    minShift: null,
  },
  video: {
    useProIdiom: false,
  },
  tv: {
    aspect_ratio: 6, // 6 - original  |  2 - 16:9  |  4 - zoom | 9 - for Full HD
    welcome_format: '{w}, {t} {l}',
    greeting_format: '{t} {l}',
    date_format: 'dd.mm.yy',
    date_status_exist: true,
    parental_lock_status_exist: false,
    time_status_exist: true,
    wakeup_status_exist: true,
    channel_sorting: false,
    wakeup: {
      channel: 1,
      start_volume: 1,
      end_volume: 20,
    },
    start_volume: {
      enabled: false,
      volume: 10,
    },
    volume_control: 'native', //'native','hoteza'
    mosaic_clock: {
      enabled: false,
    },
    messages_listener: 'longpoll', // longpoll для longpoll, poll для im по куям, ws для websocket, epmty для
    // обычного запроса im
    polling: {
      messages: {
        longpoll_timeout: 20 * 1000,
        longpoll_retry_timeout: 10 * 1000,
        poll_timeout: 10 * 1000,
        poll_error_timeout: 20 * 1000,
      },
      events: {
        longpoll_timeout: 20 * 1000,
        reconnect_timeout: 20 * 1000,
      },
    },
    vod: {
      enabled: false,
      categories_in_menu: false,
      use_pay: false,
      use_media_fragment_uri: true,
      confirm_by: 'room', // room, pin, sum. default - room
      use_purchases: false,
    },

    welcome_screen: {
      //object {'channel': 2, 'volume': 10}
      enabled: true,
      always: true,
      channel: 0,
      volume: 10,
      useGroupsInWelcome: true,
      hide_button: false,
    },
    page_type: PageType.Standard, // 'standard' | 'fullscreen_image' | 'image_wide'
    pagelist_type: PageListType.Standard, // 'standard' | 'hub'
    parental_lock: false,
    sleep_timer: {
      //For custom timers add "data": [10,20,30] (mins)
      enabled: true,
    },
    checkin_action: '',
    checkout_action: 'poweroff',
    allowed_apps: ['Tanks', 'YouTube'],
    additional_apps: {}, //'youtube': ['app_id']
    external_devices: ['SOURCES', 'MIRACAST', 'USB'],
    allowed_sources: [
      ['HDMI', 0],
      ['HDMI', 1],
    ],
    roomcontrol: false,

    //true in production
    suppress_log: false,
    service_codes_lock: false,
    configure_hide: false,

    welcome_select_language: false,

    channels_languages_override: [], //Add or replace languages here
    channels_languages_order: ['locale'], //Reorder languages in channels filter. e.g. ['locale', 'en'] puts
    // interface language first, English second, then the rest languages
    settings_languages_order: [], //Reorder languages on change language page. e.g. ['ar'] puts Arabic to first
    // place

    allow_register_by_pin: false,

    tvids: [
      'not set',
      'Bedroom',
      'Living Room',
      'Bathroom',
      'TV 4',
      'TV 5',
      'TV 6',
      'TV 7',
      'TV 8',
      'TV 9',
      'TV 10',
    ],
    hacks: {
      // set title from menuItem to Sources Page title
      useMenuTitleForSourcesPage: true,
      tv_registration_v2: true,
      tvip_handle_power_button: false,
      tvip_handle_cec: false,
      lg_magic_pixel: false,

      // добавлено для случая, когда звук транслируется сторонним устройством и громкостью управляет оно (приставка к
      // ТВ, ТВ с саундбаром)
      volume_control_disable: false,
      philips: {
        stop_channel_before_launch_next: false,
      },
    },

    mouse_control: false,
    cursor_animation: false,
    reboot_in_standby: false, //Reboot instead of reload
    autoconfigure: false,

    philips: {
      debug: false,
    },

    auto_poweroff: {
      enabled: false, // Enable switch
      poweroff_time: 6, // Hours until poweroff trigger (default to 6 hours)
      autoclose_time: 60, // Seconds to autoclose dialog and do action (default 60 seconds)
      action: 'poweroff', // Action on timeout. (poweroff|reboot|reload) (default to poweroff)
    },
    CustomNotification: {
      disable: false,
    },
    additionalKeycodes: {
      // EXAMPLE
      // lg: [{
      // 	keycode: 0,
      // 	virtualKeycode: '201804', // tv_keys.CUSTOM_BLUETOOTH
      // 	fn: function () {
      // 		log.add('Press button: tv_keys.CUSTOM_BLUETOOTH, code: '+ tv_keys.CUSTOM_BLUETOOTH);
      // 		if (fullscreen) {
      // 			tv_mode();
      //
      // 			return setTimeout(function () {
      // 				promiseAllSettled([__exitHdmi(), Apps.destroy({id: '244115188075859015'})])
      // 					.then(function () {
      // 						Apps.open('bluetooth');
      // 					});
      // 			}, 500);
      // 		}
      //
      // 		promiseAllSettled([__exitHdmi(), Apps.destroy({id: '244115188075859015'})])
      // 			.then(function () {
      // 				Apps.open('bluetooth');
      // 			});
      // 	}
      // }, {
      // 	keycode: 0,
      // 	virtualKeycode: '201805', // tv_keys.CUSTOM_INPUT
      // 	fn: function () {
      // 		log.add('Press button: tv_keys.CUSTOM_INPUT, code: '+ tv_keys.CUSTOM_INPUT);
      // 		promiseAllSettled([__exitHdmi(), Apps.destroy({id: '244115188075859015'})])
      // 			.then(function () {
      // 				Sources.open_source('input','hdmi1');
      // 			});
      // 	}
      // }, {
      // 	keycode: 0,
      // 	virtualKeycode: '201802', // tv_keys.CUSTOM_CHROMECAST
      // 	fn: function () {
      // 		log.add('Press button: tv_keys.CUSTOM_CHROMECAST, code: '+ tv_keys.CUSTOM_CHROMECAST);
      // 		promiseAllSettled([__exitHdmi(), Apps.destroy({id: '244115188075859015'})])
      // 			.then(function () {
      //         Sources.open_source('hotezastream_chromecast');
      // 			});
      // 	}
      // }, {
      // 	keycode: 0,
      // 	virtualKeycode: '201803', // tv_keys.CUSTOM_AIRPLAY
      // 	fn: function () {
      // 		log.add('Press button: tv_keys.CUSTOM_AIRPLAY, code: '+ tv_keys.CUSTOM_AIRPLAY);
      // 		promiseAllSettled([__exitHdmi(), Apps.destroy({id: '244115188075859015'})])
      // 			.then(function () {
      //         Sources.open_source('hotezastream_appletv');
      // 			});
      // 	}
      // }, {
      // 	keycode: 0,
      // 	virtualKeycode: '201801', // tv_keys.CUSTOM_TV
      // 	fn: function () {
      // 		log.add('Press button: tv_keys.CUSTOM_TV, code: '+ tv_keys.CUSTOM_TV),
      //     tv_mode();
      // 	}
      // }]
    },

    // android: {
    // 	apps: [{
    // 		packageName: 'com.hoteza.tv',
    // 		url: 'https://usercontent.hoteza.tv/jm8xefb/UsWXd8NEc6Gn',
    // 		version: '1.1.0'
    // 	}]
    // }
  },
};
